module.exports = __webpack_public_path__ + "static/img/testBg.fee710c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test/testBg.jpg
// module id = Y4fI
// module chunks = 6